<template lang="html">
  <div :class="{'pt-2 tabs':!mobile}" v-hotkey="keymap">
    <div class="position-relative" :class="{'container':!mobile}">
      <b-list-group class="mobile-tabs d-block d-lg-none position-absolute w-100">
        <b-list-group-item button
          class="d-flex justify-content-between"
          :class="{ 'bg-active' : mode === 'rhyme' }"
          @click="setModel('rhyme')">
          חרוזים
          <i class="fas fa-check" v-if="mode === 'rhyme'"></i>
        </b-list-group-item>
        <b-list-group-item button
          class="d-flex justify-content-between" 
          :class="{ 'bg-active' : mode === 'xxsonance' }" 
          @click="setModel('xxsonance')">
          מצלול
           <i class="fas fa-check" v-if="mode === 'xxsonance'"></i>
          </b-list-group-item>  
        <b-list-group-item button
          class="d-flex justify-content-between"
          :class="{ 'bg-active' : mode === 'alliteration' }"
          @click="setModel('alliteration')">
          אליטרציה
           <i class="fas fa-check" v-if="mode === 'alliteration'"></i>
        </b-list-group-item>
<!--         <b-list-group-item button
          class="d-flex justify-content-between" 
          :class="{ 'bg-active' : mode === 'tavnit' }"
          @click="setModel('tavnit')">
          תבנית מילה
          <i class="fas fa-check" v-if="mode === 'tavnit'"></i>
        </b-list-group-item>     -->    
      </b-list-group>
      <div class="btn-group d-none d-lg-block">
        <b-button 
          variant="link"
          class="rounded-top shadow-none"
          :class="{ 'bg-light' : mode === 'rhyme' }"
          @click="setModel('rhyme')"          
          >
          <p class="mb-0">{{hebrew ? 'חרוזים' : 'Rhymes'}}</p>
        </b-button>
        <b-button 
          variant="link"
          class="rounded-top shadow-none"
          :class="{ 'bg-light' : mode === 'xxsonance' }"
          @click="setModel('xxsonance')"
          >
          <p class="mb-0">{{hebrew ? 'מצלול' : 'Assonance'}}</p>
        </b-button>
        <b-button 
          variant="link"
          class="rounded-top shadow-none"
          :class="{ 'bg-light' : mode === 'alliteration' }"
          @click="setModel('alliteration')"
          >
          <p class="mb-0">{{hebrew ? 'אליטרציה' : 'Alliteration'}}</p>
        </b-button>
        <b-button 
          variant="link"
          class="rounded-top shadow-none"
          :class="{ 'bg-light' : mode === 'tavnit' }"
          @click="setModel('tavnit')"
          >
          <p class="mb-0">{{hebrew ? 'תבנית מילה' : 'Pattern'}}</p>
        </b-button>        
      </div>
    </div>   
  </div>
</template>

<script lang="js">
  function gtag() { window.dataLayer.push(arguments) }
  import {Actions} from '@/store/stateChanges'
  export default  {
    name: 'Tabs',
    props: [],
    data() {
      return {
        
      }      
    }, 
    methods: {
      setModel (value) {           
        gtag('event', 'Tab clicked', {
        'event_category': 'selection',
        'event_label': value
        })       
        this.$store.commit('SET_OVERVIEW', true)        
        if (this.searchedWord.length > 0) {
          this.$store.commit('SET_MODEL', value)   
          this.$emit('set')
          this.$store.dispatch(Actions.RUN_CHARUZIT) 
        }  
        else {
          this.$store.commit('CLEAR_RESULTS')
          this.$store.commit('SET_MODEL', value)   
          this.$emit('set')
        }

      }
    },
    computed: {
      keymap () {
        return {
          'shift+r': () => {
            document.activeElement.blur()
            this.setModel('rhyme')
          },
          'shift+s': () => {
            document.activeElement.blur()
            this.setModel('xxsonance')
          },
          'shift+a': () => {
            document.activeElement.blur()
            this.setModel('alliteration')
          },
          'shift+p': () => {
            document.activeElement.blur()
            this.setModel('tavnit')
          },                           
        }
      },
      mode () {
        return this.$store.state.searchModel
      },      
      mobile () {
        return this.$mq === 'xs'
      }, 
      hebrew () {
      return this.$settings.hebrew
    },
    searchedWord () {
      return this.$store.state.textForCharuzitApiCall
    }    
  }
}
</script>
<style scoped lang="scss">
  .mobile-tabs {    
    z-index: 3;
    left: 0;
    top: 0;
    border-radius: 6px;
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.2);
    .bg-active {
      background: #e3e3e3!important;
    }
    button {
      i {
        line-height: 24px;
      }
      &:first-of-type {
        border-radius: 6px 6px 0 0;
      }
      &:last-of-type {
        border-radius: 0 0 6px 6px;
      }
    }
  }
  .tabs{
    background: #d6ecff;
    .btn {
      font-size: 16px;
      border-radius: 0;
      padding: 1px 21px;
      &:not(.bg-light){
        background: transparent!important;
        &:hover {
          background: #C8E3FB!important;
        }
      }
    }
    button.bg-light.active, .button.bg-light:active,
    button.bg-light.focus, 
    button.bg-light:focus, button.bg-light:hover{
      background: #fbfbfb!important;
    }        
  }   
</style>
